import Vue from 'vue'
import { createImage} from '~image'
import NuxtImg from '~image/components/nuxt-img.vue'
import NuxtPicture from '~image/components/nuxt-picture.vue'

import * as staticRuntime$2786 from '/home/runner/work/EnsoHeadless/EnsoHeadless/node_modules/@nuxt/image/dist/runtime/providers/static.js'
import * as contentfulRuntime$97af from '/home/runner/work/EnsoHeadless/EnsoHeadless/node_modules/@nuxt/image/dist/runtime/providers/contentful.js'
import * as storyblokRuntime$8df5 from '/home/runner/work/EnsoHeadless/EnsoHeadless/node_modules/@nuxt/image/dist/runtime/providers/storyblok.js'
import * as cloudflareRuntime$d99b from '/home/runner/work/EnsoHeadless/EnsoHeadless/node_modules/@nuxt/image/dist/runtime/providers/cloudflare.js'
import * as shopifyRuntime$29b9 from '/home/runner/work/EnsoHeadless/EnsoHeadless/modules/shopify/nuxt-img-provider.js'

const imageOptions = {
  "screens": {
    "xs": 600,
    "sm": 900,
    "md": 1200,
    "lg": 1500,
    "xl": 1800,
    "xxl": 2000,
    "2xl": 1536,
    "3xl": 2600
  },
  "presets": {
    "card-image": {
      "modifiers": {
        "format": "webp",
        "quality": 100,
        "width": 300
      }
    },
    "nav-card": {
      "modifiers": {
        "format": "webp",
        "quality": 100,
        "width": 200
      }
    },
    "display-carousel": {
      "modifiers": {
        "format": "webp",
        "quality": 100
      }
    },
    "featured-products": {
      "modifiers": {
        "format": "webp",
        "quality": 100
      }
    },
    "hero": {
      "modifiers": {
        "format": "webp",
        "quality": 100
      }
    }
  },
  "provider": "static",
  "domains": [
    "cdn.shopify.com"
  ],
  "alias": {}
}

imageOptions.providers = {
  ['static']: { provider: staticRuntime$2786, defaults: {} },
  ['contentful']: { provider: contentfulRuntime$97af, defaults: {} },
  ['storyblok']: { provider: storyblokRuntime$8df5, defaults: {"baseURL":"https://a-us.storyblok.com"} },
  ['cloudflare']: { provider: cloudflareRuntime$d99b, defaults: {"baseURL":"/api/v1/image"} },
  ['shopify']: { provider: shopifyRuntime$29b9, defaults: undefined }
}

Vue.component(NuxtImg.name, NuxtImg)
Vue.component(NuxtPicture.name, NuxtPicture)
Vue.component('NImg', NuxtImg)
Vue.component('NPicture', NuxtPicture)

export default function (nuxtContext, inject) {
  const $img = createImage(imageOptions, nuxtContext)

  if (process.static && process.server) {
    nuxtContext.beforeNuxtRender(({ nuxtState }) => {
      const ssrData = nuxtState.data[0] || {}
      ssrData._img = nuxtState._img || {}
    })
  }

  inject('img', $img)
}
